// extracted by mini-css-extract-plugin
module.exports = {"featuredSection":"ResourcesList_featuredSection__r2vlq","grid":"ResourcesList_grid__nTIaX","fadeIn":"ResourcesList_fadeIn__6Belc"};